import React, { memo, MutableRefObject } from 'react';

import { classNameBind } from '@wconcept/wconcept-ui/utils/common';

import * as S from './style';

interface IProps {
  className?: string;
  id?: string;
  children?: React.ReactNode;
  isRef?: React.LegacyRef<HTMLElement> | undefined;
}

const Anchor = ({ className, id, children, isRef }: IProps) => {
  const cName = classNameBind(['Anchor', className || '']);

  return (
    <S.Anchor ref={isRef} className={cName} id={id}>
      {children}
    </S.Anchor>
  );
};

export default memo(Anchor);
